<template>
    <div class="step-title">
        <div class="step-status-icon" :class="{ active, error, complete }">
            <DsIcon :name="icon" />
        </div>

        {{ title }}
    </div>
</template>

<script>
export default {
    props: {
        active: Boolean,
        error: Boolean,
        complete: Boolean,
        title: String,
    },

    computed: {
        icon() {
            return this.error ? 'alert-triangle-fill' : 'check';
        },
    },
}
</script>

<style scoped lang="scss">
$stage-icon-size: px-to-rem(26px);

.step-title {
    display: flex;
    align-items: center;
    font-size: $font-size-lg;
    font-weight: $font-weight-semibold;
    width: px-to-rem(220);
}

.step-status-icon {
    @include circle($stage-icon-size);
    border: solid 2px $color-gray-200;
    background-color: $color-paper;
    height: $stage-icon-size;
    width: $stage-icon-size;
    color: $color-gray-200;
    @include margin-end($spacing-100);
    --icon-size: #{$icon-size-small};

    &.active {
        border-color: $color-blue;
        color: $color-blue;
    }

    &.error {
        border: none;
        color: $color-red;

        --icon-color: #{$color-red};
        --icon-size: #{$stage-icon-size};
    }

    &.complete {
        background-color: $color-blue;
        border-color: $color-blue;

        --icon-color: #{$color-paper};
        --icon-size: #{$icon-size-small};
    }
}
</style>